<!-- Overlay Mode: Shows spinner on top of content -->
@if (overlay) {
  <div
    class="loading-state"
    [class.loading-state--active]="loading"
    [style.minHeight]="loading && minHeight ? minHeight : null">

    <!-- Loading Overlay -->
    @if (loading) {
      <div class="loading-state__overlay" role="status" aria-live="polite">
        <div class="loading-state__spinner-container">
          <app-spinner [size]="size" [variant]="variant"></app-spinner>
          @if (message) {
            <p class="loading-state__message">{{ message | translate }}</p>
          }
        </div>
      </div>
    }

    <!-- Content (always rendered, dimmed when loading) -->
    <div class="loading-state__content" [attr.aria-busy]="loading">
      <ng-content></ng-content>
    </div>
  </div>
}

<!-- Replace Mode: Hides content while loading -->
@if (!overlay) {
  @if (loading) {
    <div
      class="loading-state loading-state--replace"
      [style.minHeight]="minHeight || '100px'"
      role="status"
      aria-live="polite">
      <div class="loading-state__spinner-container">
        <app-spinner [size]="size" [variant]="variant"></app-spinner>
        @if (message) {
          <p class="loading-state__message">{{ message | translate }}</p>
        }
      </div>
    </div>
  } @else {
    <ng-content></ng-content>
  }
}
